import styled from '../../../styles/theme';
import { ToggleStyled } from '../ToggleStyled';
import { rem } from 'polished';

export const ToggleStyledAC = styled(ToggleStyled)`
    .toggleHandle {
        background: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.grey1};
    }
    .toggleHandleContainer {
        background-color: ${({ theme }) => theme.colors.primary};
        border: 1px solid ${({ theme }) => theme.colors.primary};
    }
    .toggleOptions {
        justify-content: space-between;
    }
    .toggleOption {
        color: ${({ theme }) => theme.colors.grey2};
        font-weight: ${props => props.theme.fontWeights.textBold};
        font-size: ${rem('15px')};
        &.toggled {
            color: ${({ theme }) => theme.colors.grey5};
        }
    }
`;
